import { BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-common';

export const environment = {
  production: true,
  name: 'stage',
  isStation: true,
  apis: {
    appInsights: {
      instrumentationKey: '86330b32-05aa-4059-9488-f1f2e7e13a06', // appinsightsstg-nim-client-station
    },
    azure: {
      correlationTokenName: 'abc-correlation-token',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '01dfdd3a2d514361b790d221f03352e9',
    },
    diagnosisCode: {
      endpointUrl: '',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '437beccc74d74c9bbc91169de834b00c',
    },
    entitlements: {},
    emrintegration: {},
    formulary: {},
    identity: {},
    inventory: {},
    lookup: {},
    party: {},
    purchaseorder: {},
    patient: {},
    physician: {},
    stationmanagement: {},
    printing: {
      endpointUrl: 'https://services.stage.hdp.amerisourcebergen.com/Printing',
    },
    configuration: {
      endpointUrl: 'https://services.stage.hdp.amerisourcebergen.com/configuration',
    },
    pricing: {
      endpointUrl: 'https://services.stage.hdp.amerisourcebergen.com/Pricing',
    },
  },
  useStateManagement: false,
  useApiPrinting: false,
  msalConfig: {
    interactionType: InteractionType.Popup,
    auth: {
      clientId: 'a1d0d596-9651-4d36-9e43-f0113a0a2f24',
      navigateToLoginRequestUrl: false,
      redirectUri: '/auth',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggingOptions: {
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  },
  apiConfig: {
    scopes: ['a1d0d596-9651-4d36-9e43-f0113a0a2f24'],
    uri: 'https://services.stage.hdp.amerisourcebergen.com',
    anonymousEndpoints: [],
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_local_signin',
      resetPassword: 'B2C_1A_local_signin',
      editProfile: 'B2C_1A_local_signin',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://PSGCustomerStage.b2clogin.com/PSGCustomerStage.onmicrosoft.com/B2C_1A_local_signin',
      },
      resetPassword: {
        authority: 'https://PSGCustomerStage.b2clogin.com/PSGCustomerStage.onmicrosoft.com/B2C_1A_local_signin',
      },
      editProfile: {
        authority: 'https://PSGCustomerStage.b2clogin.com/PSGCustomerStage.onmicrosoft.com/B2C_1A_local_signin',
      },
    },
    authorityDomain: 'PSGCustomerStage.b2clogin.com',
  },
  cmsUrl: 'https://cms.nucleusinventory.com/cms/production/stationmvp/',
};
